import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@standardnotes/snjs';
import IconButton from '@/Components/Button/IconButton';
import StyledTooltip from '@/Components/StyledTooltip/StyledTooltip';
export function getCSSValueFromAlignment(format) {
    switch (format) {
        case 'start':
        case 'left':
            return 'start';
        case 'right':
        case 'end':
            return 'end';
        default:
            return 'center';
    }
}
const Options = [
    {
        alignment: 'left',
        label: 'Left align',
    },
    {
        alignment: 'center',
        label: 'Center align',
    },
    {
        alignment: 'right',
        label: 'Right align',
    },
];
export function ImageAlignmentOptions({ alignment: currentAlignment, changeAlignment, }) {
    return Options.map(({ alignment, label }) => (_jsx(StyledTooltip, { label: label, children: _jsx(IconButton, { className: classNames(alignment === currentAlignment && '!bg-info text-info-contrast', 'rounded p-1 hover:bg-contrast'), icon: `format-align-${alignment}`, title: label, focusable: true, onClick: (e) => {
                // the preventDefault and stopPropagation for these events are required
                // so that the keyboard doesn't jump when you select another option
                e.preventDefault();
                e.stopPropagation();
                changeAlignment(alignment);
            }, onMouseDown: (e) => {
                e.preventDefault();
            } }) }, alignment)));
}
